// -----------------  FETCH TV CATEGORIES -----------------
export const FETCH_TV_CATEGORY_LOADING = 'FETCH_TV_CATEGORY_LOADING';
export const FETCH_TV_CATEGORY_SUCCESS = 'FETCH_TV_CATEGORY_SUCCESS';
export const FETCH_TV_CATEGORY_ERROR = 'FETCH_TV_CATEGORY_ERROR';
